import { useEffect, useState } from 'react';

import { ErrorBoundary } from '@sentry/react';
import TripOption from './TripOption';
import lokalise from 'utils/lokalise';

function TripOptions({ tripOptions, selectTripOption, searchingTrips, params }) {
    

    if (searchingTrips || !tripOptions) return null;

    const [groupedTrips, setGroupedTrips] = useState(null);

    const sortGroupedObject = (obj) => {
        const entries = Object.entries(obj);
      
        // Separate entries
        const shuttleEntry = entries.find(([key]) => key === 'Shuttle');
        const walkEntry = entries.find(([key]) => key === 'Walk');
        const middleEntries = entries.filter(([key]) => key !== 'Shuttle' && key !== 'Walk');
      
        // Build new object in the desired order
        const result = {};
        if (shuttleEntry) {
            result[shuttleEntry[0]] = shuttleEntry[1];
        };
        for (const [key, value] of middleEntries) {
          result[key] = value;
        }
        if (walkEntry) result[walkEntry[0]] = walkEntry[1];
      
        return result;
    };

    useEffect(() => {
        let grouped = {};
        tripOptions.forEach((trip, i) => {

            if (i === 0) trip.recommended = true;

            trip.mode = trip.category;

            //Shuttle comes in as Transit category but we need to separate them. Hence filter it out first by name
            if (trip.name === 'shuttle') {
                trip.mode = 'Shuttle';
                if (grouped['shuttle']) {
                    grouped['shuttle'].push(trip);
                } else {
                    grouped['shuttle'] = [trip];
                }
            }
            else if (trip.category === 'RideHailing') {
                grouped['Drive'] = grouped['Drive'] || [];
                grouped['Drive'].push(trip);
            }
            else if (grouped[trip.category]) {
                grouped[trip.category].push(trip);
            } else {
                grouped[trip.category] = [trip];
            }
        })
        setGroupedTrips(sortGroupedObject(grouped));
    }, [tripOptions]);

    return (
        <div className="TripOptions">
            <ErrorBoundary fallback={<>{lokalise.getKey("ts11q")}</>}>
                {(!groupedTrips || Object.keys(groupedTrips).length === 0) && <p className="trip-group-title">There are no trip options available</p>}

                {groupedTrips && Object.values(groupedTrips).map((group, i) => {
                    return (<div key={i} className="trip-group">
                        <h3>{lokalise.getReverseKey(group[0].mode)}</h3>
                        <div className="trip-group-content">
                            {
                                group.map((tripOption, i) => {
                                    return <TripOption key={i} tripOption={tripOption} selectTripOption={selectTripOption} params={params} />
                                })
                            }
                        </div>
                    </div>)

                })}

            </ErrorBoundary>
        </div>
    )
}

export default TripOptions;
